import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import ProtectedRoute from '../component/ProtectedRoute';

import {
  Callback
} from "../Pages/IS";

import {
  Login,
  Home
} from "../Pages/IS";

const IS = () => (
  <Routes>
    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<Login />} />
    <Route path="/callback" element={<Callback />} />
    <Route path="/home" element={<ProtectedRoute element={<Home />} role={27} />} />
  </Routes>
);

export default IS;

